import {c, color, theme, is_mobile} from './modules/settings.js';

(function ($) {
  jQuery(document).ready(function($) {
    (function setAnchor() {
        $('.ns-anchor').each(function () {
            var $self = $(this);
            $self.css({
               'width': '100%'
            });
        });
    })();

    if(window.location.hash){
      setTimeout(goToHash, 1000);
    }

    function goToHash(){
            $([document.documentElement, document.body]).animate({
              scrollTop: $(window.location.hash).offset().top - ($('.page-section--header').outerHeight() - $('.page-section--subheader').outerHeight())
            }, 400);
      }

  });
})(jQuery);